import { isExpired } from '@/utils/dateTimeUtils';

/**
 * A project can be shared when it is published (not hidden), not cancelled,
 * not expired (by endDate/date per specificDate) and has no missing fields.
 * Completion is not checked directly: completing a project hides it
 * automatically (published=false), and a steward can unhide it, after which
 * it is shareable again. A completed project never counts as expired.
 *
 * @param {Object} [data] - project.data
 * @param {Object} [options]
 * @param {boolean} [options.isIncomplete] - true while missing fields are loading or any are missing
 * @returns {boolean}
 */
export default function isProjectShareable(data, { isIncomplete = false } = {}) {
  if (!data || isIncomplete) {
    return false;
  }

  const lastDate = data.specificDate === 'Yes' ? data.date : data.endDate;
  const expired = !data.completed && isExpired(lastDate);

  return data.published === true && !data.cancelled && !expired;
}
